import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { API_BASE_URL } from '../services/api';
import '../styles/AuthPages.css';

const ForgotPasswordPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    username: ''
  });
  const [useEmail, setUseEmail] = useState(true);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear messages when user starts typing
    if (message || error) {
      setMessage('');
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const identifier = useEmail ? formData.email : formData.username;
    if (!identifier.trim()) {
      setError(`Please enter your ${useEmail ? 'email' : 'username'}`);
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    try {
      const requestBody = useEmail 
        ? { email: formData.email } 
        : { username: formData.username };

      const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message || 'If a matching account is found, a password reset link has been sent to the registered email address.');
        setFormData({ email: '', username: '' });
      } else {
        setError(data.error || 'An error occurred while processing your request');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      setError('Network error. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  const toggleMode = () => {
    setUseEmail(!useEmail);
    setFormData({ email: '', username: '' });
    setMessage('');
    setError('');
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <h1 className="auth-title">Reset Your Password</h1>
        </div>
        <p className="auth-subtitle">
          Enter your {useEmail ? 'email address' : 'username'} and we'll send you instructions to reset your password
        </p>

        {message && <div className="auth-success">{message}</div>}
        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="auth-form-group">
            <label className="auth-label">
              {useEmail ? 'Email Address' : 'Username'}
            </label>
            <input
              type={useEmail ? 'email' : 'text'}
              name={useEmail ? 'email' : 'username'}
              value={useEmail ? formData.email : formData.username}
              onChange={handleInputChange}
              placeholder={useEmail ? 'Enter your email address' : 'Enter your username'}
              className="auth-input"
              disabled={loading}
              autoFocus
            />
          </div>

          <button type="submit" disabled={loading} className="auth-btn">
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>

          <div className="auth-center">
            <button
              type="button"
              onClick={toggleMode}
              className="auth-link-btn"
              disabled={loading}
            >
              Use {useEmail ? 'username' : 'email'} instead
            </button>
          </div>

          <div className="auth-center">
            <Link to="/login" className="auth-link">← Back to Login</Link>
          </div>
        </form>

        {!message && (
          <div className="auth-note">
            <strong>Note:</strong> If you don't receive an email within a few minutes, please check your spam folder or contact your system administrator.
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;